import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IContact, IDescribedStringObject, ILocation, ILocationExtended, IQuestion } from '../../../../../type_definitions/datatypes';
import { PriceCartService } from '../../cart/price-cart.service';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { IOrderEntryOverviewModel, IOrderLeasePrices, IOrderPrices, IOrderThankYou, IRequesterAddress, OrderEntryDataService, ProcurementType } from '../order-entry-data.service';
import { IDocumentGroup } from '../documents/order-entry-documents-data.service';
import { BodyClassService } from '../../../../shared/services/body-class.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { OrderEntryWebshopService } from '../webshop/order-entry-webshop.service';
import { GaMessageService } from '../../../../shared/message/ga-message.service';
import { SurveyDataService } from '../../../../shared/survey/survey-data.service';
import _ from 'underscore';
import { util } from '../../../../shared/util';
import { IOrderFee, PriceCartDataService } from '../../cart/price-cart-data.service';
import { OrderBPOverviewComponent } from './order-bp-overview.component';
import { LocationInfoComponent } from '../location-info/location-info.component';
import { OrderEntryInvoiceService } from '../location/invoice/order-entry-invoice.service';
import { OrderEntryPaymentService } from '../payment/order-entry-payment.service';
import { OrderEntryInfoService } from '../order-info/order-entry-info.service';
import { OrderEntryRequesterService } from '../requester/order-entry-requester.service';
import { OrderEntryShippingService } from '../location/shipping/order-entry-shipping.service';
import { OrderEntryService } from '../order-entry.service';
import { IContactModel } from '../location/base-order-entry-location-to.service';
import { SurveyQuestionsComponent } from '../../../../shared/survey/survey-questions.component';

const ORDERENTRY_OVERVIEW_CLASS:string = 'orderentry-overview';

@Component({
  selector: 'order-entry-overview',
  template: `
    <h2 translate>ORDERENTRY.OVERVIEW.TITLE</h2>

    <div class="clearfix">
      <div class="col-md-12 thankyou" *ngIf="thankyouMessage">
        <i class="fa fa-check-circle-o"></i>
        <span [innerHTML]="thankyouMessage"></span>
      </div>

      <div class="col-md-12 warning" *ngIf="warningMessage">
        <i class="fa fa-warning warning"></i>
        <span [innerHTML]="warningMessage"></span>
      </div>

      <div class="col-md-12 docWarning" *ngIf="documentWarnings?.length">
        <i class="fa fa-warning"></i>
        <span translate>ORDERENTRY.OVERVIEW.REQUIRED_DOCS</span>
        <ul>
          <li *ngFor="let warning of documentWarnings; trackBy: trackByFunction">
            {{ warning.typeInfo }}
            <a href [scrollTarget]="warning.typeCode">
              <span translate [translateParams]="{ label: warning.type }">GA.UPLOADS.UPLOAD_LABEL</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <ol class="toc hidden-print">
      <li><a scrollAnchor="overviewCart" href *ngIf="model.cart.cartStatus"><span translate>ORDERENTRY.CART.TITLE</span></a></li>
      <li><a scrollAnchor="overviewOrderinfo" href><span translate>ORDERENTRY.ORDERINFO.TITLE</span></a></li>
      <li><a scrollAnchor="overviewRequester" href *ngIf="model.requester.contact || model.requester.address">
        <span translate>ORDERENTRY.WEBSHOP.LABELS.REQUESTER</span>
      </a></li>
      <li><a scrollAnchor="overviewShipping" href><span translate>ORDERENTRY.OVERVIEW.SHIPPED_TO</span></a></li>
      <li><a scrollAnchor="overviewShippedFrom" href><span translate>ORDERENTRY.OVERVIEW.SHIPPED_FROM</span></a></li>
      <li><a scrollAnchor="overviewInvoice" href><span translate>ORDERENTRY.OVERVIEW.INVOICE_TO</span></a></li>
      <li><a scrollAnchor="overviewInvoicedBy" href><span translate>ORDERENTRY.OVERVIEW.INVOICE_BY</span></a></li>
      <li><a scrollAnchor="overviewDocuments" href><span translate>ORDERENTRY.DOCS.TITLE</span></a></li>
    </ol>

    <!-- Cart -->
    <div class="row" id="shopping-cart">
      <div class="col-sm-12">
        <h4 class="form-title ng-scope" translate>ORDERENTRY.CART.TITLE</h4>
        <order-entry-overview-items [hidePrices]="hidePrices" [leasePrices]="leasePrices" [purchasePrices]="purchasePrices" [lamFee]="lamFee" [acslFee]="acslFee" [showLease]="showLease"></order-entry-overview-items>
      </div>
    </div>

    <!-- Order Info & Requester -->
    <div class="row order-overview">
      <div class="col-sm-12 col-md-6">
        <formly scrollTarget="overviewOrderinfo" [form]="orderInfoForm" [fields]="orderInfoFields" [model]="model.orderInfo"></formly>  
      </div>
      
      <div class="col-sm-12 col-md-6">
        <formly scrollTarget="overviewRequester" [form]="requesterForm" [fields]="requesterFields" [model]="model.requester"></formly>
      </div>
    </div>

    <!-- Shipping info -->
    <div class="row order-overview">
      <div class="col-sm-12 col-md-6">
        <formly scrollTarget="overviewShipping" [form]="shippedToForm" [fields]="shippedToFields" [model]="model.shippedTo"></formly>  
      </div>
      
      <div class="col-sm-12 col-md-6">
        <formly scrollTarget="overviewShippedFrom" [form]="shippedFromForm" [fields]="shippedFromFields" [model]="model.shippedFrom"></formly>
      </div>
    </div>

    <!-- Invoice info -->
    <div class="row order-overview" *ngIf="!hideOrderEntryInvoiceTab">
      <div class="col-sm-12 col-md-6 invoice-to">
        <formly scrollTarget="overviewInvoice" [form]="invoiceToForm" [fields]="invoiceToFields" [model]="model.invoiceTo"></formly>  
      </div>
      
      <div class="col-sm-12 col-md-6 invoice-by">
        <formly scrollTarget="overviewInvoicedBy" [form]="invoiceByForm" [fields]="invoiceByFields" [model]="model.invoiceBy"></formly>  
      </div>
    </div>

    <!-- Documents -->
    <div class="row order-overview">
      <div scrollTarget="overviewDocuments" class="order-overview col-sm-12 d-print-none">
        <h4 class="form-title" translate>ORDERENTRY.DOCS.TITLE</h4>
        <order-entry-documents [showUpload]="false" [editable]="false" [showTitle]="false" [orderId]="orderId"></order-entry-documents>
      </div>
    </div>
  `,
  styleUrls: ['./order-entry-overview.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderEntryOverviewComponent implements OnInit, OnDestroy {
  @Input() public orderId:number;
  @Input() public isPaid:boolean;

  public purchasePrices:IOrderPrices;
  public leasePrices:IOrderLeasePrices;
  public showLease:boolean;
  public hidePrices:boolean;
  public lamFee:string;
  public acslFee:string;
  public thankyouMessage:string;
  public warningMessage:string;
  public documentWarnings:IDocumentGroup[];
  public hideOrderEntryInvoiceTab:boolean;

  public orderInfoForm:UntypedFormGroup = new UntypedFormGroup({});
  public requesterForm:UntypedFormGroup = new UntypedFormGroup({});
  public shippedToForm:UntypedFormGroup = new UntypedFormGroup({});
  public shippedFromForm:UntypedFormGroup = new UntypedFormGroup({});
  public invoiceToForm:UntypedFormGroup = new UntypedFormGroup({});
  public invoiceByForm:UntypedFormGroup = new UntypedFormGroup({});

  public orderInfoFields:IExtraFieldConfigurationObject[] = [];
  public requesterFields:IExtraFieldConfigurationObject[] = [];
  public shippedToFields:IExtraFieldConfigurationObject[] = [];
  public shippedFromFields:IExtraFieldConfigurationObject[] = [];
  public invoiceToFields:IExtraFieldConfigurationObject[] = [];
  public invoiceByFields:IExtraFieldConfigurationObject[] = [];
  public model:IOrderEntryOverviewModel = <any>{};

  private hasCountryInfoQuestions:boolean = true;
  private labelClass:string = 'col-sm-2 col-md-3';
  private valueClass:string = 'col-sm-10 col-md-9';

  private surveyQuestionField:IExtraFieldConfigurationObject;

  constructor(
    private bodyClassService:BodyClassService,
    private orderEntryWebshopService:OrderEntryWebshopService,
    private messageService:GaMessageService,
    private orderDataService:OrderEntryDataService,
    private surveyDataService:SurveyDataService,
    private priceCartService:PriceCartService,
    private priceCartDataService:PriceCartDataService,
    private formattingService:FormattingService,
    private orderEntryInvoiceService:OrderEntryInvoiceService,
    private orderEntryService:OrderEntryService,
    private orderEntryPaymentService:OrderEntryPaymentService,
    private orderEntryInfoService:OrderEntryInfoService,
    private orderEntryRequesterService:OrderEntryRequesterService,
    private orderEntryShippingService:OrderEntryShippingService,
    private formlyService:GaFormlyService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.bodyClassService.add(ORDERENTRY_OVERVIEW_CLASS);
    this.hidePrices = this.orderEntryWebshopService.shopContext?.hidePrices;
    this.showLease = this.orderEntryWebshopService.shopContext?.defaultProcurementType === ProcurementType.LEASE;
    this.hideOrderEntryInvoiceTab = this.orderEntryWebshopService.shopContext?.hideOrderEntryInvoiceTab;
    this.initModel();
    this.displayPaymentConfirmationMessage();
    this.loadThankyouMessage();
    this.loadCountryInfo();
    this.loadFees();
    this.createFields();
  }

  public ngOnDestroy():void {
    this.bodyClassService.remove(ORDERENTRY_OVERVIEW_CLASS);
  }

  public trackByFunction(item:IDocumentGroup):number {
    return item.caveatDefinitionId;
  }

  private createFields():void {
    this.orderInfoFields = this.createOrderInfoFields();
    this.requesterFields = this.createRequesterFields();
    this.shippedToFields = this.createShippedToFields();
    this.shippedFromFields = this.createShippedFromFields();
    this.invoiceToFields = this.createInvoiceToFields();
    this.invoiceByFields = this.createInvoiceByFields();
  }

  private initModel():void {
    this.model = <any>{};

    // Country Info
    this.model.country = <any>{};
    this.model.country.selectedShop = this.orderEntryWebshopService.selectedShop;
    this.model.country.selectedCountry = this.orderEntryWebshopService.selectedCountry;
    this.model.country.selectedBP = this.orderEntryWebshopService.selectedBP;

    // Cart
    this.model.cart = <any>{};
    this.model.cart.cartStatus = this.priceCartService.cartStatus;
    this.model.cart.hasWarnings = this.priceCartService.hasWarnings;

    // Requester
    this.model.requester = <any>{};
    this.model.requester.contact = this.orderEntryRequesterService.contact;
    this.model.requester.address = this.orderEntryRequesterService.address;

    // Order Info
    this.model.orderInfo = <any>{};
    this.model.orderInfo.orderCreationDate = this.orderEntryInfoService.orderCreationDate;
    this.model.orderInfo.description = this.orderEntryInfoService.description;
    this.model.orderInfo.referenceCustomer = this.orderEntryInfoService.referenceCustomer;
    this.model.orderInfo.customerPONumber = this.orderEntryInfoService.customerPONumber;
    this.model.orderInfo.arrivalDate = this.orderEntryInfoService.arrivalDate;
    this.model.orderInfo.orderType = this.orderEntryInfoService.orderType;
    this.model.orderInfo.stockOrderType = this.orderEntryInfoService.stockOrderType;
    this.model.orderInfo.payment = this.orderEntryPaymentService.paymentType;
    this.model.orderInfo.comment = this.orderEntryInfoService.comment;
    this.model.orderInfo.tagValue = this.orderEntryInfoService.tagValue;
    this.model.orderInfo.tagValue2 = this.orderEntryInfoService.tagValue2;
    this.model.orderInfo.costCenter = this.orderEntryInfoService.costCenter;

    // Payment
    this.model.payment = <any>{};
    if (this.orderEntryPaymentService.paymentType) {
      const possiblePaymentTypes:IDescribedStringObject[] = this.orderEntryPaymentService.getPossiblePaymentTypes();
      this.model.orderInfo.payment = _.findWhere(possiblePaymentTypes, { id: this.orderEntryPaymentService.paymentType.id });
      this.model.payment.paymentType = this.orderEntryPaymentService.paymentType;
    }
    this.model.payment.customerPONumber = this.orderEntryInfoService.customerPONumber;

    // Shipping to
    this.model.shippedTo = <any>{};
    this.model.shippedTo.address = this.orderEntryShippingService.addressData;
    this.model.shippedTo.office = this.model.shippedTo.address?.office;
    this.model.shippedTo.contact = this.orderEntryShippingService.contactData;
    this.model.shippedTo.comments = this.orderEntryShippingService.comments;
    this.model.shippedTo.overnight = this.orderEntryShippingService.overnight;

    // Shipping from
    this.model.shippedFrom = <any>{};
    this.model.shippedFrom.bp = <ILocationExtended>this.orderEntryWebshopService.shopContext?.bp.location;

    // Invoice
    this.model.invoiceTo = <any>{};
    this.model.invoiceTo.address = this.orderEntryInvoiceService.addressData;
    this.model.invoiceTo.office = this.model.invoiceTo.address?.office;
    this.model.invoiceTo.contact = this.orderEntryInvoiceService.contactData;
    this.model.invoiceTo.comments = this.orderEntryInvoiceService.comments;
    this.model.invoiceTo.eInvoiceMailAddress = this.orderEntryInvoiceService.eInvoiceMailAddress;

    // Invoiced By
    this.model.invoiceBy = <any>{};
    this.model.invoiceBy.address = <any>{};
    util.setValue(this.model.invoiceBy.address, 'address', this.orderEntryService.order.invoiceby.address, true);
    util.setValue(this.model.invoiceBy.address, 'city', this.orderEntryService.order.invoiceby.city, true);
    util.setValue(this.model.invoiceBy.address, 'company', this.orderEntryService.order.invoiceby.company, true);
    util.setValue(this.model.invoiceBy.address, 'country', this.orderEntryService.order.invoiceby.country, true);
    util.setValue(this.model.invoiceBy.address, 'zipCode', this.orderEntryService.order.invoiceby.zipCode, true);
    this.model.invoiceBy.contact = <any>{};
    util.setValue(this.model.invoiceBy.contact, 'fullName', this.orderEntryService.order.invoiceby.contact, true);

    // Prices: Total & Subtotal
    // if procurement type is leasing and 'hidePrices' flag is true then use lease prices otherwise use purchase prices
    this.purchasePrices = this.orderEntryService.order.purchasePrices;
    this.leasePrices = this.orderEntryService.order.leasePrices;
  }

  private displayPaymentConfirmationMessage():void {
    // for credit card and Paypal payments display a message after redirect back to ga2
    if (this.isPaid && this.model.payment.paymentType && /^(CC|PP)$/.test(this.model.payment.paymentType.id)) {
      this.messageService.showFeedbackMessage('ORDERENTRY.PAYMENT.PAYMENT_CONFIRMATION_MESSAGE');
    }
  }

  private loadThankyouMessage():void {
    const webshopId:number = this.orderEntryWebshopService.selectedShop.id;
    const countryId:number = this.orderEntryWebshopService.selectedCountry.id;
    const companyCountryId:number = this.orderEntryWebshopService.selectedBP.id;

    this.orderDataService.thankyou(webshopId, countryId, companyCountryId, this.orderId)
      .then((data:IOrderThankYou) => {
        this.warningMessage = data.warnings;
        this.thankyouMessage = data.thankYou;
        this.documentWarnings = data.documents;
      });
  }

  private loadCountryInfo():void {
    this.surveyDataService.getSurveyQuestions(this.orderEntryWebshopService.selectedCountry?.id, SurveyDataService.WORKFLOW_COUNTRY)
      .then((questions:IQuestion[]) => {
        const answeredQuestions:IQuestion[] = _.filter(questions, (question:IQuestion) => !util.isNullOrUndefinedOrEmpty(question.answer));
        this.model.shippedFrom.countryInfoQuestions = answeredQuestions;

        if (this.surveyQuestionField) {
          this.surveyQuestionField.templateOptions.inputs.questions = answeredQuestions;
        }

        this.hasCountryInfoQuestions = answeredQuestions.length > 0;
      });
  }

  private loadFees():void {
    this.model.fees = <any>{};

    if (this.orderEntryWebshopService.shopContext?.lamFeeDisplayAllowed || this.orderEntryWebshopService.shopContext?.acslFeeDisplayAllowed) {
      this.priceCartDataService.getOrderFees(this.orderEntryWebshopService.selectedShop.id, this.orderEntryWebshopService.selectedCountry.id, this.orderId, this.priceCartService.currency)
        .then((fees:IOrderFee) => {
          if (this.orderEntryWebshopService.shopContext?.lamFeeDisplayAllowed) {
            this.lamFee = this.formattingService.formatAmount(fees.lamFee, this.priceCartService.currency);
          }
          if (this.orderEntryWebshopService.shopContext?.acslFeeDisplayAllowed) {
            this.acslFee = this.formattingService.formatAmount(fees.acslFee, this.priceCartService.currency);
          }
        });
    }
  }

  private createOrderInfoFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle('ORDERENTRY.ORDERINFO.TITLE')
        .build(),
      this.formlyService.aValue('orderCreationDate', 'ORDERENTRY.ORDERINFO.CREATION_DATE')
        .withFormat(this.formattingService.formatDate)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.orderCreationDate))
        .build(),
      this.formlyService.aValue('description', 'ORDERENTRY.ORDERINFO.DESCRIPTION')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.description))
        .build(),
      this.formlyService.aValue('referenceCustomer', 'ORDERENTRY.ORDERINFO.REF_CUST')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.referenceCustomer))
        .build(),
      this.formlyService.aValue('customerPONumber', 'ORDERENTRY.ORDERINFO.PONR')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.customerPONumber))
        .build(),
      this.formlyService.aValue('arrivalDate', 'ORDERENTRY.ORDERINFO.ARR_DATE')
        .withFormat(this.formattingService.formatDate)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.arrivalDate))
        .build(),
      this.formlyService.aValue('orderType', 'ORDERENTRY.ORDERINFO.ORDER_TYPE')
        .withFormat(this.formattingService.formatLov)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.orderType))
        .build(),
      this.formlyService.aValue('stockOrderType', 'ORDERENTRY.ORDERINFO.STOCK_ORDER_TYPE')
        .withFormat(this.formattingService.formatLov)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.stockOrderType))
        .build(),
      this.formlyService.aValue('costCenter', 'ORDERENTRY.ORDERINFO.COST_CENTER')
        .withFormat(this.formattingService.formatLov)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.costCenter))
        .build(),
      this.formlyService.aValue('tagValue', this.orderEntryWebshopService.shopContext?.tagField?.label)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.tagValue) && !this.orderEntryWebshopService.shopContext?.tagField)
        .build(),
      this.formlyService.aValue('tagValue2', this.orderEntryWebshopService.shopContext?.tagField2?.label)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.tagValue2) && !this.orderEntryWebshopService.shopContext?.tagField2)
        .build(),
      this.formlyService.aValue('payment', 'ORDERENTRY.PAYMENT.TITLE')
        .withFormat(this.formattingService.formatDescription)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.payment))
        .build(),
      this.formlyService.aValue('comment', 'GA.GENERAL.COMMENTS')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.orderInfo?.comment))
        .build()
    ];
  }

  private createRequesterFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle('ORDERENTRY.WEBSHOP.LABELS.REQUESTER')
        .build(),
      this.createGeneralAddressField(this.model.requester?.address?.location, this.model.requester?.address?.vat?.name),
      this.createContactField(this.model.requester?.contact)
    ];
  }

  private createShippedToFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle('ORDERENTRY.OVERVIEW.SHIPPED_TO')
        .build(),
      this.createGeneralAddressField(this.model.shippedTo?.address?.location, this.model.shippedTo?.address?.vatName),
      this.createOfficeField(this.model.shippedTo?.office),
      this.createContactField(this.model.shippedTo?.contact),
      this.createCommentsField(this.model.shippedTo?.comments),
      this.formlyService.aValue('overnight', 'ORDERENTRY.SHIPPING.OVERNIGHT')
        .withFormat(this.formattingService.formatBoolean)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.shippedTo?.overnight))
        .build()
    ];
  }

  private createShippedFromFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle('ORDERENTRY.OVERVIEW.SHIPPED_FROM')
        .build(),
      this.formlyService.aCustom('GA.GENERAL.BP')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withComponent(OrderBPOverviewComponent)
        .withExtraOptions({
          templateOptions: {
            inputs: {
              model: this.model.shippedFrom
            }
          }
        })
        .build(),
      this.surveyQuestionField = this.formlyService.aCustom('ORDERENTRY.WEBSHOP.TITLE')
        .withComponent(SurveyQuestionsComponent)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withWrapperClass('country-info')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              questions: this.model.shippedFrom?.countryInfoQuestions
            }
          }
        })
        .withHideExpression(() => !this.hasCountryInfoQuestions)
        .build()
    ];
  }

  private createInvoiceToFields():IExtraFieldConfigurationObject[] {
    if (this.orderEntryInvoiceService.billingType) {
      this.model.invoiceTo.billingType = <'LOCAL' | 'CENTRAL'>this.orderEntryInvoiceService.billingType.id;
    }

    return [
      this.formlyService.aTitle('ORDERENTRY.OVERVIEW.INVOICE_TO')
        .build(),
      this.createGeneralAddressField(this.model.invoiceTo?.address?.location, this.model.invoiceTo?.address?.vatName),
      this.createOfficeField(this.model.invoiceTo?.office),
      this.formlyService.aValue('eInvoiceMailAddress', 'ORDERENTRY.INVOICE.E_INVOICE.TITLE')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.invoiceTo?.eInvoiceMailAddress))
        .build(),
      this.createContactField(this.model.invoiceTo?.contact),
      this.createCommentsField(this.model.invoiceTo?.comments)
    ];
  }

  private createInvoiceByFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle(`ORDERENTRY.OVERVIEW.INVOICE_BY_${this.model.invoiceTo?.billingType}`)
        .build(),
      this.createGeneralAddressField(this.model.invoiceBy?.address),
      this.createContactField(this.model.invoiceBy?.contact)
    ];
  }

  private createGeneralAddressField(location?:IRequesterAddress|ILocation|ILocationExtended, vatName?:string):IExtraFieldConfigurationObject {
    return this.formlyService.aCustom('GA.GENERAL.ADDRESS')
      .withLabelClass(this.labelClass)
      .withValueClass(this.valueClass)
      .withComponent(LocationInfoComponent)
      .withExtraOptions({
        templateOptions: {
          inputs: {
            location,
            vatName
          }
        }
      })
      .withHideExpression(() => util.isNullOrUndefinedOrEmpty(location))
      .build();
  }

  private createContactField(model?:IContact|IContactModel):IExtraFieldConfigurationObject {
    return this.formlyService.aValue('contact', 'GA.GENERAL.CONTACT')
      .withFormat(this.formattingService.formatFullContactWithoutEmail)
      .withLabelClass(this.labelClass)
      .withValueClass(this.valueClass)
      .withHideExpression(() => util.isNullOrUndefinedOrEmpty(model))
      .build();
  }

  private createOfficeField(model?:string):IExtraFieldConfigurationObject {
    return this.formlyService.aValue('office', 'GA.GENERAL.OFFICE')
      .withLabelClass(this.labelClass)
      .withValueClass(this.valueClass)
      .withHideExpression(() => util.isNullOrUndefinedOrEmpty(model))
      .build();
  }

  private createCommentsField(model?:string):IExtraFieldConfigurationObject {
    return this.formlyService.aValue('comments', 'GA.GENERAL.COMMENTS')
      .withLabelClass(this.labelClass)
      .withValueClass(this.valueClass)
      .withHideExpression(() => util.isNullOrUndefinedOrEmpty(model))
      .build();
  }
}